import React from 'react';
import { Icon } from 'Components';
import styles from './BulkActionsBar.module.scss';

interface BulkActionsBarProps {
	selectedCount: number;
	onSelectAll: () => void;
	onDeselectAll: () => void;
	onReset: () => void;
	onUnassign: () => void;
	resetDisabled?: boolean;
	resetDisabledReason?: string;
}

const BulkActionsBar: React.FC<BulkActionsBarProps> = ({
	selectedCount,
	onSelectAll,
	onDeselectAll,
	onReset,
	onUnassign,
	resetDisabled = false,
	resetDisabledReason
}) => {
	return (
		<div className={styles.bar}>
			<div className={styles.item}>
				<span className={styles.selectedIndicator}>
					<Icon type="check" role="img" />
				</span>
				<span className={styles.selectedCount}>
					{selectedCount} Selected
				</span>
			</div>

			<div className={styles.item}>
				<button
					className={`${styles.actionBtn} ${styles['actionBtn--selectAll']}`}
					onClick={onSelectAll}
				>
					Select All
				</button>
			</div>

			<div className={styles.item}>
				<button
					className={`${styles.actionBtn} ${styles['actionBtn--selectAll']}`}
					onClick={onDeselectAll}
				>
					Deselect All
				</button>
			</div>

			<div className={styles.item}>
				<button
					className={`${styles.actionBtn} ${styles['actionBtn--reset']}`}
					onClick={onReset}
					disabled={resetDisabled}
					title={resetDisabled ? resetDisabledReason : undefined}
				>
					<span className={styles.resetIcon}>
						<Icon type="reset" role="img" />
					</span>
					Reset
				</button>
			</div>

			<div className={styles.item}>
				<button
					className={`${styles.actionBtn} ${styles['actionBtn--unassign']}`}
					onClick={onUnassign}
				>
					<span className={styles.deleteIcon}>
						<Icon type="redBin" role="img" />
					</span>
					Unassign
				</button>
			</div>
		</div>
	);
};

export default BulkActionsBar;
